class ChekiCampaignStatus extends HTMLElement {
  connectedCallback() {
    const orderId = new URLSearchParams(window.location.search).get('order_id');
    if (!orderId) {
      this.render('invalid_order');
      return;
    }

    const url = `${this.dataset.proxyUrl}?order_id=${encodeURIComponent(orderId)}`;
    fetch(url, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((data) => this.render(data.status))
      .catch(() => this.render('error'));
  }

  render(status) {
    const template =
      this.querySelector(`template[data-status="${status}"]`) ||
      this.querySelector('template[data-status="error"]');
    if (!template) return;
    this.innerHTML = '';
    this.appendChild(template.content.cloneNode(true));
    this.executeScripts();
  }

  executeScripts() {
    this.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      for (const attr of oldScript.attributes) {
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }
}

customElements.define('cheki-campaign-status', ChekiCampaignStatus);
